import { browserHistory, createRoutes, match } from 'react-router';
import { routes } from './routes';
import { getVersion } from 'releases';
import * as Sentry from '@sentry/react';
import {
  getEventsCount,
  getSessionId,
  syncSubscribers,
  trackSessionEvent,
} from '@services/session-tracker/sessionTracker';
import { User } from './components/auth';

export const beforeErrorSend = async (event: Sentry.ErrorEvent) => {
  trackSessionEvent('SentryErrorEvent', event);
  await syncSubscribers();
  const sessionId = getSessionId();
  event.extra = { ...event.extra, sessionId, eventsCount: getEventsCount() };
  return event;
};

export const initSentry = () =>
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV3BrowserTracingIntegration({
        history: browserHistory,
        routes: createRoutes(routes),
        match: match,
      }),
      Sentry.browserApiErrorsIntegration({
        XMLHttpRequest: false,
        setTimeout: false,
        setInterval: false,
        requestAnimationFrame: false,
      }),
      Sentry.browserProfilingIntegration(),
      Sentry.breadcrumbsIntegration({
        // TODO: add relevant breadcrumbs
        fetch: false,
        console: false,
        dom: false,
        history: false,
        sentry: false,
        xhr: false,
      }),
    ],
    ignoreErrors: [new RegExp('ResizeObserver loop')],
    release: getVersion(),
    tracesSampleRate: 1.0,
    enabled: import.meta.env.VITE_ENV !== 'development',
    environment: import.meta.env.VITE_ENV,
    debug: import.meta.env.VITE_ENV === 'development',
    beforeSend: beforeErrorSend,
  });

export function identifySentry(user: User) {
  if (!user || !user.id) {
    Sentry.setUser(null);
    return;
  }

  const creatorName = user.influencer
    ? `${user.influencer?.firstName} ${user.influencer?.lastName}`
    : '';

  Sentry.setUser({
    id: String(user.id),
    name: `${import.meta.env.VITE_ENV} | ${user.firstName} ${user.lastName} ${
      creatorName ? `(${creatorName})` : ''
    }`,
    email: user.email,
    influencerId: user.influencerId,
    influencer: user.influencer,
    role: user.role,
    sessionId: getSessionId(),
  });
}
